export default class OrderStatus {
  static get WaitPayment () { return 'waitPayment' } //  Ожидает оплаты
  static get New () { return 'new' } //  Новый заказ
  static get Confirm () { return 'confirm' } //  Потверждён
  static get Preparing () { return 'preparing' } //  Готовится
  static get Assembly () { return 'assembly' } //  В сборке
  static get ReadyForIssue () { return 'readyForIssue' } //  Готов к выдаче
  static get InDelivery () { return 'inDelivery' } //  Достовляется
  static get Completed () { return 'completed' } //  Завершён
  static get Canceled () { return 'canceled' } //  Отменен

  static get visibleStatuses () {
    return [
      OrderStatus.New,
      OrderStatus.Confirm,
      OrderStatus.Preparing,
      OrderStatus.Assembly,
      OrderStatus.ReadyForIssue,
      OrderStatus.InDelivery,
      OrderStatus.Completed,
      OrderStatus.Canceled,
    ]
  }

  // Состав заморожен: заказ в сборке или дальше
  static get prohibitingItemsEditingStatuses () {
    return [
      OrderStatus.Assembly,
      OrderStatus.ReadyForIssue,
      OrderStatus.InDelivery,
      OrderStatus.Completed,
      OrderStatus.Canceled,
    ]
  }

  // Доставку не поменять: курьер в пути или заказ закрыт
  static get prohibitingDeliveryChangeStatuses () {
    return [
      OrderStatus.InDelivery,
      OrderStatus.Completed,
      OrderStatus.Canceled,
    ]
  }

  // Филиал заморожен: еда уже готовится на своей точке
  static get prohibitingFilialChangeStatuses () {
    return [
      OrderStatus.Preparing,
      OrderStatus.Assembly,
      OrderStatus.ReadyForIssue,
      OrderStatus.InDelivery,
      OrderStatus.Completed,
      OrderStatus.Canceled,
    ]
  }

  static get closedStatuses () {
    return [
      OrderStatus.Completed,
      OrderStatus.Canceled,
    ]
  }

  // палитра статусов - как в карточке заказа (Status.vue, getBackgroundColor)
  static get statusColors () {
    return {
      [OrderStatus.New]: { color: '#FF9100' },
      [OrderStatus.WaitPayment]: { color: '#F4B083' },
      [OrderStatus.Confirm]: { color: '#FF9100', colorPreorder: '#4a4a4a' },
      [OrderStatus.Preparing]: { color: '#38B2B2' },
      [OrderStatus.Assembly]: { color: '#614EE2' },
      [OrderStatus.ReadyForIssue]: { color: '#ABDB49' },
      [OrderStatus.InDelivery]: { color: '#1EBFE9' },
      [OrderStatus.Completed]: { color: '#17c970' },
      [OrderStatus.Canceled]: { color: '#C9C9C9' },
    }
  }

  static getName (enumValue) {
    switch (enumValue) {
      case OrderStatus.WaitPayment: return 'Ожидает оплаты'
      case OrderStatus.New: return 'Новый заказ'
      case OrderStatus.Confirm: return 'Подтверждён'
      case OrderStatus.Preparing: return 'Готовится'
      case OrderStatus.Assembly: return 'В сборке'
      case OrderStatus.ReadyForIssue: return 'Готов к выдаче'
      case OrderStatus.InDelivery: return 'Доставляется'
      case OrderStatus.Completed: return 'Завершён'
      case OrderStatus.Canceled: return 'Отменен'

      default: return enumValue
    }
  }

  static getVisibleStatusesWithNames () {
    return OrderStatus.visibleStatuses.map((status) => ({
      value: status,
      title: OrderStatus.getName(status),
    }))
  }
}
